export default class lang {
    Langs = ['JA'];
    Text:texts;

    constructor(lang:number){
        this.Text = langs[lang];

    }

}


const langs:Array<texts> = [
    {
        appTitle:"安否確認システム",
        manualA:"操作マニュアル",
        loginTitle:"ログイン",
        logout:"ログアウト",
        redirectLogin:"ログインする",
        chgPassword:"パスワード変更",
        setTotp:"ワンタイムパスワードの設定",
        pCode:"社員番号",
        userId:"ユーザーID",
        userName:"名前",
        depertment:"所属",
        password:"パスワード",
        otpCode:"ワンタイムパスワード",
        authFail:"ログイン情報が間違っています",
        authLock:"あなたのログイン試行はロックされました",
        authUnLock:"しばらく待ってからやり直ししてください",
        yes:"はい",
        no:"いいえ",
        ok:"OK",
        close:"閉じる",
        cancel:"キャンセル",
        confn:"確認",
        edit:"編集",
        save:"保存",
        templete:"テンプレート",
        secretKey:"シークレットキー",
        unknowDef:"不明",
        earthquake:"地震",
        tsunami:"津波",
        training:"訓練",
        minutes:"分",
        add:"追加",
        remove:"削除",
        update:"更新",
        config:"設定",
        contactAdress:"安否確認の受信先を4つまで登録できます（但しLINEは１件のみ)",
        lineUser:"LINE",
        notConf:"未確認",
        adressTite:"受信先登録",
        mailAdress:"メールアドレス",
        submit:"送信",
        reportTitle:"下記質問に回答してください",
        required:"必須",
        reportView:"回答状況確認",
        quakeLeve:"震度",
        proxyAdress:"代理回答者",
        ecEvent:"安否送信",
        mailconfig:"受信先登録",
        report:"回答する",
        excel:"Excelファイル",
        messegeSubject:"概要",
        sendMessege:"メッセージ送信",
        send:"送信",
        messegeText:"メッセージ",
        answerUser:"回答者",
        person:"本人",
        serchCodeName:"フィルター:社員番号or氏名",
        serchDepName:"フィルター:コードor部署名",
        answerReport:"回答入力",
        memoDetail:"確認メモ",
        inputMemo:"メモ入力",
        dataGetDate:"データ取得日時",
        chatTitle:"全体メモ",
        validTooLong:"入力文字が長すぎます",
        passwordRule:"8文字以上設定してください",
        passwordRuleScore:"複雑なパスワードにしてください",
        warning:"警告",
        loading:"Loading...",
        reportHead:"回答状況",
        reportHeadHelp:"グラフをクリックすると回答一覧を絞り込みます",
        reportListHead:"回答一覧",
        reportListHeadHelp:"カーソルを合わせるとメモを確認できます、右クリックでメニューが表示されます",
        ecMemo:{
            title:"確認メモ",
            noMemo:"メモの記入はありません",
            date:"入力日時",
            user:"入力者",
            text:"内容",
            seeOther:"他%count 件のメモがあります",
        },
        answer:{
            sub:"回答状況",
            act:"回答済",
            dct:"未回答",
        },
        columnSelectItem:{
            text:"テキスト入力",
            select:"選択",
        },
        adressType:{
            mail:"メール",
            line:"LINE",
            proxy:"代理",
        },
        payColmun:{
            periodText:"yyyy年mn月分",
            salary:"給与",
            bonus:"賞与",
            withholdingtax:"源泉徴収票",
        },
        functionName:{
            passwordChange:"パスワードの変更",
            currentPassword:"現在のパスワード",
            newPassword:"新しいパスワード",
            newPasswordV:"新しいパスワード(確認)",
            setTopt:"ワンタイムパスワード設定",
            totpSet:"ワンタイムパスワード設定",
            totpCl:"ワンタイムパスワード解除",
        },
        administrator:{
            title:"管理画面",
            tabUsers:"ユーザー管理",
            tabConfig:"設定",
            addUser:"ユーザー追加",
            noData:"ユーザーが見つかりません",
            confAddUser:"上記情報で追加してよろしいですか？",
            setNewPassword:"パスワードを設定しました",
            reSetPassword:"パスワード再設定",
            confResetPssword:"パスワードを再設定してもよろしいですか？",
            printPdf:"パスワード情報印刷",
            area:"地域",
            maxInt:"震度",
            ecStartTitle:"安否確認要請実施判断",
            ecStartText:"安否確認を実施しますか？",
            ecEventList:"安否確認一覧",
            ecEventListHelp:"クリックすると詳細が表示されます",
            ecEventClose:"回答収集を終了する",
            unknowAdressUser:"連絡先未設定のユーザー",
            useProxyUsers:"代理人設定のユーザー",
            proxyUser:"代理人",
            traning:"安否確認実施",
            noReportUser:"未回答者がいます。",
            lockCloseBtn:"回答収集を終了する",
            eventColumn:{
                date:"登録日時",
                mode:"状態",
                overview:"概要",
            },
            listColumn:{
                userId:"社員番号",
                alias:"別番号",
                userName:"名前",
                depertment:"所属",
                empCode:"個人コード",
                isRetire:"退職済",
                lastLogin:"最終ログイン",
                useTotp:"OTP有効",
                resetPassword:"パスワード発行",
            },
            conditLolumn:{
                area:"地域",
                maxInt:"震度",
            },
            conifg:{
                exView:{
                    title:"回答確認権限設定",
                    detai:"通常権限から確認可能権限を変更します",
                    exUser:"個人",
                    exDep:"部署",
                    allow:"許可",
                    deny:"拒否",
                    user:"ユーザー",
                    selectUsr:"ユーザー選択",
                    check:"閲覧可能ユーザー確認",
                    allowList:"閲覧可能ユーザー",
                    allAllowList:"全ユーザー閲覧権限確認(excel)",
                },
                dep:{
                    title:"発信除外",
                    detail:"選択された部署に所属しているユーザーを安否確認の対象外とします",
                    deplist:"部署",
                    setdep:"除外所属",
                },
                msessege:{
                    root:"送信メッセージ",
                    subject:"件名",
                    precall:"発信確認",
                    call:"安否確認要請",
                    callProxy:"代理回答依頼",
                },
                reportColumn:{
                    root:"安否確認項目",
                    title:"項目名",
                    required:"必須",
                    type:"種類",
                    selectItem:"選択肢",
                },
                adminuser:{
                    title:"判断者ユーザー",
                    text:"安否確認の実施を判断するユーザー",
                    addBtn:"ユーザ追加",
                    listColumn:{
                        userid:"社員番号",
                        name:"氏名",
                        remove:"削除",
                    }
                },
                adminCheckTime:{
                    title:"判断者による判断時間",
                    text:"設定時間内に判断者が応答しなかった場合に通知します"
                },
                alertCondition:{
                    title:"自動通知条件",
                    text:"通知処理を行う条件を設定します",
                }
            }
        },
        messege:{
            lastLogin:"前回ログイン日時",
            invalidSession:"現在のセッションが無効になりました、再度ログインしてください",
            dbSccess:"処理が完了しました",
            regedUser:"登録済みユーザーです",
            unknowUser:"ユーザーが見つかりません",
            warnMultiUser:"複数のユーザーが見つかりました",
            selectUser:"ユーザーを選択してください",
            dontGetFile:"ファイルの取得に失敗しました",
            setTopt:"ワンタイムパスワードを設定します。<br>設定すると時間生成式のパスワードの入力が追加で必要になり<br>よりセキュリティを高めることができます",
            newPasswordCheckV:"新しいパスワード(確認)が一致していません",
            removeConf:"削除してもよろしいですか？",
            ecCancel:"安否確認の実施を中止しました",
            ecStart:"安否確認の実施を開始しました",
            invalidRequiredItem:"必須項目が入力されていません",
            reportSubmitted:"回答を送信しました",
            closeEventConf:"回答収集を終了してよろしいですか？",
            cantRedo:"※この操作は取り消しできません",
            approvalProxy:"%USERNAME (%PCODE )があなたを代理回答者として登録しようとしています",
            activeReport:"回答収集中の安否確認があります。",
            reportSetter:"こちらから自身の安否を送信することもできます",
            apprvalConf:"承認しますか？",
            sendMessegeDescription:"登録連絡先へメッセージを送信",
            textLengthOver:"メッセージが長すぎます",
            eventStart:"発信を開始しました",
            activateTotp:"正しく登録出来たか確認するためワンタイムパスワードを入力し「確認」をクリックしてください",
            activateComp:"正常に登録されました。「閉じる」で一度ログアウトしますのでワンタイムパスワードを使用しログインしてください",
            activateFail:"ワンタイムパスワードが正しくありません",
            sendedMessede:"送信しました",
            selfProxyError:"自分自身を代理人設定することは出来ません",
            templeteTitle:"名前",
            totpApp:{
                text:"ワンタイムパスワードの生成にはスマートフォンアプリが必要です<br>以下2つのアプリを推奨します<br>※ワンタイムパスワード設定後にアプリに情報を登録するため設定前にインストールしてください",
                google:{
                    name:"Google 認証システム",
                    andoroid_link:`<a href='https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png' style="border-radius: 13px; width: 200px;"></a>`,
                    iOs_link:`<a href="https://apps.apple.com/jp/app/google-authenticator/id388497605?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px;" target="_blank"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1284940800&h=7fc6b39acc8ae5a42ad4b87ff8c7f88d" alt="Download on the App Store" style="border-radius: 13px; width: 160px;"></a>`,
                },
                microsoft:{
                    name:"Microsoft Authenticator",
                    andoroid_link:`<a href='https://play.google.com/store/apps/details?id=com.azure.authenticator&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png'style="border-radius: 13px; width: 200px;"></a>`,
                    iOs_link:`<a href="https://apps.apple.com/jp/app/microsoft-authenticator/id983156458?itsct=apps_box_badge&amp;itscg=30200" style="display: inline-block; overflow: hidden; border-radius: 13px;" target="_blank"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1432944000&h=39686e6a537b2c44ff7ce60f6287e68f" alt="Download on the App Store" style="border-radius: 13px; width: 160px;"></a>`,
                }
            },
            passwordEvaluation:{
                fock:"かなり弱い",
                week:"弱い",
                soso:"そこそこ強い",
                strong:"強い",
                verystrong:"かなり強い",
            },
            totpInfo:"ワンタイムパスワードを設定しました",
            totpInfoSecret:"アプリにシークレットキーを入力するかQRコードを読み込んでください",
            totpWarnClose:"登録せずに閉じるとワンタイムパスワード発効に必要な情報が失われます",
            selectAdressType:"受信先種別を選択",
            regMail:"確認内容を送信しました、メールの内容に従って登録を完了してください",
            regMailMessege:"メールアドレスの確認が完了しました",
            regLine:{
                a:"LINE登録手順",
                b:"1:LINEでOGIHARAアカウントを友達登録する",
                c:`<a href="https://lin.ee/RNoHFcH"><img src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png" alt="友だち追加" height="36" border="0"></a>`,
                d:"2:登録コード発行ボタンをクリック",
                e:"登録コード発行",
                f:"登録コード",
                g:"3:5分以内に表示された登録コード(数字6桁)をOGIHARA宛に送信",
                h:"4:以下に「登録完了」が表示されれば完了",
                i:"%name%さん、登録完了しました",
                j:"LINEアカウントは一人一つの登録しかできません"
            },
            regProxy:{
                a:"他のユーザー(代理回答者)を連絡先とします",
                b:"代理回答者と常に連絡が取れるようにしてください",
                c:"連絡先に代理回答者を登録する場合ほかの連絡先は設定できません",
                d:"代理回答者が登録承認するまでは連絡先として無効です。"
            },
            traing:{
                a:"安否確認を行います",
                b:"メッセージを入力し「実施開始」",
                c:"",
                sw:"ロック",
                submit:"実施開始"
            }
        },
        errorMessege:{
            0:"想定外のエラーが発生しました",
            1:"サーバーが応答していません",
            500001:"データベースの接続できませんでした",
            500002:"データベースの処理に失敗しました"
        },
        quakeIndex:{
            "1":"震度1",
            "2":"震度2",
            "3":"震度3",
            "4":"震度4",
            "5-":"震度5弱",
            "5+":"震度5強",
            "6-":"震度6弱",
            "6+":"震度6強",
            "7":"震度7"
        },
        ecEventMode:{
            0:"無効化",
            1:"実施判断待ち",
            2:"回答収集中",
            3:"終了",
        }
    }
]

export interface texts{
    appTitle:string,
    manualA:string,
    loginTitle:string;
    logout:string;
    redirectLogin:string,
    chgPassword:string;
    setTotp:string;
    pCode:string;
    userId:string;
    userName:string;
    depertment:string;
    password:string;
    otpCode:string;
    authFail:string;
    authLock:string;
    authUnLock:string;
    yes:string;
    no:string;
    ok:string;
    close:string;
    cancel:string;
    confn:string;
    edit:string,
    save:string,
    templete:string,
    secretKey:string;
    unknowDef:string;
    earthquake:string;
    tsunami:string;
    training:string;
    minutes:string;
    add:string;
    remove:string;
    update:string;
    config:string;
    contactAdress:string;
    lineUser:string;
    notConf:string;
    adressTite:string;
    mailAdress:string;
    submit:string,
    reportTitle:string,
    required:string,
    reportView:string,
    quakeLeve:string,
    proxyAdress:string,
    ecEvent:string,
    mailconfig:string,
    report:string,
    excel:string,
    messegeSubject:string,
    sendMessege:string,
    send:string,
    messegeText:string,
    answerUser:string,
    person:string,
    serchCodeName:string,
    serchDepName:string,
    answerReport:string,
    memoDetail:string,
    inputMemo:string,
    dataGetDate:string,
    chatTitle:string,
    validTooLong:string,
    passwordRule:string,
    passwordRuleScore:string,
    warning:string,
    loading:string,
    reportHead:string,
    reportHeadHelp:string,
    reportListHead:string,
    reportListHeadHelp:string,
    ecMemo:{
        title:string,
        noMemo:string,
        date:string,
        user:string,
        text:string,
        seeOther:string,
    },
    answer:{
        sub:string,
        act:string,
        dct:string,
    },
    columnSelectItem:{
        text:string,
        select:string,
    },
    adressType:{
        mail:string,
        line:string,
        proxy:string,
    }
    payColmun:{
        periodText:string;
        salary:string;
        bonus:string;
        withholdingtax:string
    }
    functionName:{
        passwordChange:string,
        currentPassword:string,
        newPassword:string,
        newPasswordV:string,
        setTopt:string,
        totpSet:string,
        totpCl:string,
    },
    administrator:{
        title:string;
        tabUsers:string;
        tabConfig:string;
        addUser:string;
        noData:string;
        confAddUser:string;
        setNewPassword:string;
        reSetPassword:string;
        confResetPssword:string;
        printPdf:string,
        area:string,
        maxInt:string,
        ecStartTitle:string,
        ecStartText:string,
        ecEventList:string,
        ecEventListHelp:string,
        ecEventClose:string,
        unknowAdressUser:string,
        useProxyUsers:string,
        proxyUser:string,
        traning:string,
        noReportUser:string,
        lockCloseBtn:string,
        eventColumn:{
            date:string,
            mode:string,
            overview:string
        }
        listColumn:{
            userId:string,
            alias:string,
            userName:string,
            depertment:string,
            empCode:string,
            isRetire:string,
            lastLogin:string,
            useTotp:string,
            resetPassword:string,
        },
        conditLolumn:{
            area:string,
            maxInt:string,
        },
        conifg:{
            exView:{
                title:string,
                detai:string,
                exUser:string,
                exDep:string,
                allow:string,
                deny:string,
                user:string,
                selectUsr:string,
                check:string,
                allowList:string,
                allAllowList:string,
            },
            dep:{
                title:string,
                detail:string,
                deplist:string,
                setdep:string,
            },
            msessege:{
                root:string,
                subject:string,
                precall:string,
                call:string,
                callProxy:string,
            },
            reportColumn:{
                root:string,
                title:string,
                type:string,
                required:string,
                selectItem:string,
            },
            adminuser:{
                title:string,
                text:string,
                addBtn:string,
                listColumn:{
                    userid:string,
                    name:string,
                    remove:string,
                }
            },
            adminCheckTime:{
                title:string,
                text:string,
            },
            alertCondition:{
                title:string,
                text:string,
            }
        }
    },
    messege:{
        lastLogin:string,
        invalidSession:string,
        dbSccess:string,
        regedUser:string,
        unknowUser:string,
        warnMultiUser:string,
        selectUser:string,
        dontGetFile:string,
        setTopt:string,
        removeConf:string,
        newPasswordCheckV:string,
        ecCancel:string,
        ecStart:string,
        invalidRequiredItem:string,
        reportSubmitted:string,
        closeEventConf:string,
        cantRedo:string,
        approvalProxy:string,
        reportSetter:string,
        apprvalConf:string,
        activeReport:string,
        sendMessegeDescription:string,
        textLengthOver:string,
        eventStart:string,
        activateTotp:string,
        activateComp:string,
        activateFail:string,
        sendedMessede:string,
        selfProxyError:string,
        templeteTitle:string,
        totpApp:{
            text:string,
            google:{
                name:string,
                andoroid_link:string,
                iOs_link:string,
            },
            microsoft:{
                name:string,
                andoroid_link:string,
                iOs_link:string
            }
        },
        passwordEvaluation:{
            fock:string,
            week:string,
            soso:string,
            strong:string,
            verystrong:string,
        },
        totpInfo:string,
        totpInfoSecret:string,
        totpWarnClose:string,
        selectAdressType:string,
        regMail:string,
        regMailMessege:string,
        regLine:{
            a:string,
            b:string,
            c:string,
            d:string,
            e:string,
            f:string,
            g:string,
            h:string,
            i:string,
            j:string,
        },
        regProxy:{
            a:string,
            b:string,
            c:string,
            d:string,
        },
        traing:{
            a:string,
            b:string,
            c:string,
            sw:string,
            submit:string
        }
    },
    errorMessege:{
        [errorCode:number]:string;
    },
    quakeIndex:{
        [index:string]:string
    },
    ecEventMode:{
        [errorCode:number]:string;
    }
}
